export const FETCH_USER_COACHES = 'FETCH_USER_COACHES'
export const FETCH_USER_COACHES_SUCCESS = 'FETCH_USER_COACHES_SUCCESS'
export const FETCH_USER_COACHES_FAILURE = 'FETCH_USER_COACHES_FAILURE'

export const MANAGE_USER_COACH = 'MANAGE_USER_COACH'
export const MANAGE_USER_COACH_SUCCESS = 'MANAGE_USER_COACH_SUCCESS'
export const MANAGE_USER_COACH_FAILURE = 'MANAGE_USER_COACH_FAILURE'

export const CLEAR_STATUS = 'CLEAR_STATUS'
